export default __webpack_public_path__ + "static/media/Sadie_9781408300329.823dce47.jpg";